const defaultNotification = {
  notificationIndex: -1,
  content: '',
  type: 'info',
  dismissible: true,
  temporal: true,
  dismissCountDown: 5,
  persisted: false
};

export const notification = {
  namespaced: true,

  state: {
    notifications: []
  },

  actions: {
    addSuccess: ({ dispatch }, params) => {
      dispatch('addNotification', Object.assign(defaultNotification, { id: new Date().getTime(), ...params }, { type: 'success' }));
    },

    addError: ({ dispatch }, params) => {
      dispatch('addNotification', Object.assign(defaultNotification, { id: new Date().getTime(), ...params }, { type: 'error' }));
    },

    addWarning: ({ dispatch }, params) => {
      dispatch('addNotification', Object.assign(defaultNotification, { id: new Date().getTime(), ...params }, { type: 'warning' }));
    },

    addNotice: ({ dispatch }, params) => {
      dispatch('addNotification', Object.assign(defaultNotification, { id: new Date().getTime(), ...params }, { type: 'info' }));
    },

    addNotification: ({ commit }, n) => {
      commit('addNotification', n);
    },

    dismiss: ({ commit }, index) => {
      commit('removeNotificationByIndex', index);
    },

    emptyNotifications: ({ commit }) => {
      commit('emptyNotifications');
    }
  },

  mutations: {
    addNotification: (state, newNotification) => {
      state.notifications = state.notifications.filter((o) => o.id !== newNotification.id);
      state.notifications.push(newNotification);
    },

    removeNotificationByIndex: (state, notificationIndex) => {
      state.notifications = state.notifications.filter((x) => x.id !== notificationIndex);
    },

    emptyNotifications: (state) => {
      state.notifications = [];
    }
  },

  getters: {
    notifications(state) {
      return state.notifications;
    }
  }
};
